export const BACKEND_URL = 'http://hackwagon22.olegbash.ru/api/v1/time_forecast/';
export const REQUEST_TIMEOUT = 5000;

export const enum AppRoute {
  Root = '/',
  About = '/about',
}

export const enum APIRoute {
  Stations = 'station_list',
}

export enum NameSpace {
  Stations = 'STATIONS',
}
